import {create} from 'zustand';

const initialState = {
  id: null,
  name: '',
  tipoCadastro: '',
  moduloName: '',
  codigo: '',
  usuario: {},
};

const useGlobalStore = create((set) => ({
  data: { ...initialState },
  setField: (fieldPath, value) => {
    set((state) => {
      const newState = { ...state };
      const keys = fieldPath.split('.');
      let current = newState;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;

      return newState;
    });
  },
  clearField: (fieldPath) => {
    set((state) => {
      const newState = { ...state };
      const keys = fieldPath.split('.');
      let current = newState;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = '';
      return newState;
    });
  },
  clearAllFields: () => set({ data: { ...initialState } }),
}));

export default useGlobalStore;